import React, { useCallback, useMemo, useState } from 'react';
import { useHistory } from 'react-router';

import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from '@mui/material';

import useStores from 'hooks/use-stores';

export default function useTrialModal() {
    const history = useHistory();

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const { userStore } = useStores();

    const {
        user: { isAnonymous },
        setTrialLicense,
        loadLicenseList
    } = userStore;

    const openModal = useCallback(() => setOpen(true), []);
    const closeModal = useCallback(() => setOpen(false), []);

    const onAnchorClick = useCallback(() => {
        if (isAnonymous) {
            history.push('/trial');
        } else {
            openModal();
        }
    }, [history, isAnonymous, openModal]);

    const handleStartTrialPeriod = useCallback(() => {
        setLoading(true);
        setTrialLicense()
            .then(() => {
                loadLicenseList();
                setSuccess(true);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [loadLicenseList, setTrialLicense]);

    const modal = useMemo(
        () => (
            <Dialog open={open} onClose={closeModal}>
                <DialogTitle>Starting Trial License</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {success
                            ? 'Hooray! Now you are able to use Maximum features of Vulners.com for nearest 30 days!'
                            : 'Are you sure want to start 30-days Trial Period?'}
                    </DialogContentText>
                </DialogContent>
                {success ? (
                    <DialogActions>
                        <Button onClick={closeModal}>Close</Button>
                        <Button href="/docs/API_wrapper/api/" color="primary" target="_blank">
                            Read Docs
                        </Button>
                        <Button href="/scan" color="primary">
                            Start Scan
                        </Button>
                    </DialogActions>
                ) : (
                    <DialogActions>
                        <Button onClick={closeModal} color="primary" disabled={loading}>
                            Cancel
                        </Button>
                        <Button onClick={handleStartTrialPeriod} color="primary" autoFocus disabled={loading}>
                            {loading && (
                                <Box mr={1}>
                                    <CircularProgress size={24} />
                                </Box>
                            )}
                            Start trial
                        </Button>
                    </DialogActions>
                )}
            </Dialog>
        ),
        [closeModal, handleStartTrialPeriod, loading, open, success]
    );

    return { modal, onAnchorClick };
}
